(function() {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('saveBillPdfCtrl', ['$q', '$scope', '$http', 'uteEndpoint', 'uteModal', 'data', '$filter', 'dtmService', 'dtmServiceConstants', 'uteLocale', 'dataLayerService', function($q, $scope, $http, uteEndpoint, uteModal, data, $filter, dtmService, dtmServiceConstants, uteLocale, dataLayerService) {

    $scope.language = uteLocale.language;

    $scope.screen = 'downloadOptions';

    $scope.noSelection = false;

    $scope.selectedDocumentId = data.selectedDocumentId;
    $scope.accountNumber = data.accountNumber;
    $scope.selectedIssueDate = data.selectedIssueDate;
    $scope.listDocumentId = data.listDocumentId;
    $scope.listIssueDate = data.listIssueDate;

    var selectedBillCycle = $scope.selectedIssueDate;
    $scope.bbInvoiceLinkAndDate=[];
    if (data.bbInvoiceLinkAndDate.length > 4) {
      angular.forEach(data.bbInvoiceLinkAndDate, function(selectedDate){
        if (selectedBillCycle === selectedDate.issueDate) {
          $scope.bbInvoiceLinkAndDate[0] = selectedDate;
        }
      });
      angular.forEach(data.bbInvoiceLinkAndDate, function(selectedDate){
        if (selectedBillCycle === selectedDate.issueDate) {          
        } else {
          $scope.bbInvoiceLinkAndDate.push(selectedDate);
        }
        });
    }
    else {
      $scope.bbInvoiceLinkAndDate = data.bbInvoiceLinkAndDate;
    }




    //preselect the latest date
    angular.forEach($scope.bbInvoiceLinkAndDate, function(selectedDate){
      if (selectedDate.issueDate === selectedBillCycle) {
        selectedDate.selected = selectedDate.issueDate;
      }
    });
    //preselect cal year checkbox in case of only one bill of current year and that being preselected
    if ($scope.bbInvoiceLinkAndDate) {
      var currentYearBillCount = 0;
        angular.forEach($scope.bbInvoiceLinkAndDate, function(selectedDate){
          if (selectedDate.issueDate.match($filter('date')(new Date(), 'yyyy'))){
            currentYearBillCount++;
          }
        });
        if(currentYearBillCount === 1) {
          angular.forEach($scope.bbInvoiceLinkAndDate, function(selectedDate){
            selectedDate.issueDate === selectedBillCycle ? selectedDate.selected ? $scope.selectedAll = true : '' : '';
          });
        }
    }
    $scope.widthBill = 305;
    if ($scope.bbInvoiceLinkAndDate.length > 4) {
      $scope.widthBill = (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))? 320 : 350;
    } else {
      $scope.widthBill = (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))? 300 : 330;
    }

    $scope.resetSelection = function () {
      angular.forEach($scope.bbInvoiceLinkAndDate, function (selectedDate) { //reset the checkbox
        selectedDate.selected = false;
      });
    }

    $scope.submitSelection = function (listDates) {
      var listDatesSelected = [];
      var documentIds = [];
      angular.forEach(listDates, function (value, key) {
    		if(listDates[key].selected == listDates[key].issueDate) {
    			listDatesSelected.push(listDates[key].selected); //issue dates
		    	documentIds.push(listDates[key].documentId); //document ids
        }
      });
      if(listDatesSelected.length > 0) {
        $scope.noSelection = false;
        $scope.saveBBPdf(documentIds, listDatesSelected);
      } else {
        $scope.noSelection = true; //in case of error : no selection in the checkbox
      }
    }

    var urlsLength = 0;
    $scope.count = 0;
    $scope.downloadCount = [];

    //promise to download pdf url
    $scope.downloadPdf = function(url) {
      var deferred = $q.defer();
      $http({
        method: 'get',
        url: url,
        headers: {
          'Content-type': 'application/pdf'
        },
        responseType: 'blob'
        }).success(
          function(response){
          deferred.resolve(response);
        }).error(function(errorResponse){
           deferred.reject(errorResponse);
        });
      return deferred.promise;
    };

    $scope.saveBBPdf = function(documentIds, listDatesSelected) {
  	  angular.forEach($scope.bbInvoiceLinkAndDate, function (selectedDate) { //reset the checkbox
        selectedDate.selected = false;
      });
  	  $scope.screen = 'loading';
  	  if ($scope.screen == 'loading') {
        $('.save-print-bill-modal-specific .modal-content').addClass('loading-modal-radius');
        (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))? $('.save-print-bill-modal-specific .modal-content').css('right','0px') : '';
      }
      var listDatesSelected = listDatesSelected;
	    var documentIds = documentIds;
      var tokenNumberForDownloadBill = '';

  	  $http({
        method: 'POST',
        url: uteEndpoint('olb/retrieveBBToken'),
        data: {
          accountNumber: $scope.accountNumber
        }
      }).success(function(tokenNumber) {
        if (tokenNumber){

          tokenNumberForDownloadBill = tokenNumber.token;

          var urls = [];
          angular.forEach(documentIds, function (value,key) {
            urls.push("rogers_rest/rogers/" + documentIds[key] + ".pdf?EncryptedToken=" + encodeURIComponent(tokenNumberForDownloadBill));
          });
          urlsLength = urls.length;
          var fileName = [];

          angular.forEach(urls, function(value,key) {
            var billCycle = $filter('date')(listDatesSelected[key], 'MMMdd_yyyy');
            fileName.push(billCycle);
          });
          angular.forEach(urls, function(value,key) {
            $scope.downloadPdf(urls[key]).then(function(response){
              if(response) {
                $scope.count++;
                var file = new Blob([response], {type: 'pdf'});
                var filename = 'Fido-' + fileName[key] + '.pdf';
                if (window.navigator.msSaveOrOpenBlob) { // IE10+
                  window.navigator.msSaveOrOpenBlob(file, filename);
                  $scope.screen = 'downloadSuccess';
                  $scope.pdfSuccess = true;
                  // $scope.analyticsTrackingSuccess();
                }
                else {
                  var a = $('<a style="display: none;"/>');
                  var url = URL.createObjectURL(file);
                  a.attr('href', url);
                  a.attr('download', filename);
                  $('body').append(a);
                  a[0].click();
                  setTimeout(function() {window.URL.revokeObjectURL(url);},200); // Added time out for firefox, as it removes the link before invoking
                  $scope.screen = 'downloadSuccess';
                  $scope.pdfSuccess = true;
                  // $scope.analyticsTrackingSuccess();
                }
              } else {
                $scope.screen = 'error';
                $scope.pdfSuccess = false;
              }
              if ($scope.screen == 'downloadSuccess' || $scope.screen == 'error'){
                $('.save-print-bill-modal-specific .modal-content').addClass('success-modal-radius');
              }
            }, function(errorResponse){
              $scope.screen = 'error';
              $scope.pdfSuccess = false;
              if ($scope.screen == 'error') {
                $('.save-print-bill-modal-specific .modal-content').addClass('success-modal-radius');
              }
              $scope.analyticsTrackingFailure(urls[key], errorResponse);
            });
          });
        }
      }).error(function(data){
        var apiUrl = 'olb/retrieveBBToken';
        $scope.analyticsTrackingFailure(apiUrl, data);
        $scope.screen = 'error';
        $scope.pdfSuccess = false;
        if ($scope.screen == 'error') {
          $('.save-print-bill-modal-specific .modal-content').addClass('success-modal-radius');
        }
      });
    };

    // $scope.analyticsTrackingSuccess = function () {
      // try{
      //   // var option = ($scope.bbInvoiceLinkAndDate.length === urlsLength)? 'all' : ($scope.selectedAll)? 'calendar year' : 'selected';//Removed, not being used currently
      //   var  page = dtmServiceConstants.dataLayerTrack.page.saveMultipleBill;
      //   var AnalyticsDataLayer = {
      //     'page': page,
      //     'events': {
      //       'selfServeComplete': true
      //     },
      //     'selfServe': {
      //       'type': 'inquiry',
      //       'name': 'myaccount save this bill - pdf'
      //     }
      //   };
      //   ($scope.count === urlsLength)? dataLayerService.trackDataLayer(AnalyticsDataLayer, true, dtmServiceConstants.dataLayerTrack.basicPayloadInfo): '';
      // }
      // catch(e){
      //   console.log("Exception occured while tracking data layer during Save Multiple Bills as PDF -->" + e);
      // }
    // };

    $scope.analyticsTrackingFailure =  function(apiURL, respObj) {
      try{
        var AnalyticsDataLayerError = {
          'site': {
            'name': 'F'
          },
          'page': {
            'language': uteLocale.language,
            'province': uteLocale.province,
            'referrer': window.location.href,
            'url':'modal popup'
          },
          'errors': [
            {
              'type'      : 'http',
              'category'  : 'self serve',
              'message'   : respObj && respObj.data ? respObj.data.message : respObj.statusText,
              'field'     : '',
              'code'      : respObj && respObj.data ? respObj.data.code : respObj.status,
              'API'       : apiURL
            }
          ],
          'events': {
            'pageView': true,
            'error':true
          }
        };
        dataLayerService.trackDataLayer(AnalyticsDataLayerError);
      }
      catch(e){
        console.log("Exception occured while tracking data layer during Save Multiple Bills as PDF -->" + e);
      }
    }

    var currentBillingYear = $filter('date')(new Date(), 'yyyy');

    $scope.setCheckAll = function (selectedDate) {
        $scope.noSelection = false;
    	  if ($scope.selectedAll && !selectedDate.selected) {
      		$scope.selectedAll = false;
        }
        var checkCount = 0;
    	  var curCal = 0;
        angular.forEach($scope.bbInvoiceLinkAndDate, function(selectedDate) {
            var currentYear = selectedDate.issueDate;
        		var matched = (currentYear).match(currentBillingYear);
            (matched)? curCal++ : '';
    		    if(selectedDate.selected && matched) checkCount++;
        });
          $scope.selectedAll = ( checkCount === curCal);
    };

    $scope.checkAll = function () {
      $scope.noSelection = false;
      if ($scope.selectedAll) {
        $scope.selectedAll = true;
        angular.forEach($scope.bbInvoiceLinkAndDate, function (selectedDate) {
          var currentYear = selectedDate.issueDate;
          var matched = (currentYear).match(currentBillingYear);
          selectedDate.selected = (matched) ? selectedDate.issueDate : false;
        });
      } else {
        $scope.selectedAll = false;
        angular.forEach($scope.bbInvoiceLinkAndDate, function (selectedDate) {
          var currentYear = selectedDate.issueDate;
          var matched = (currentYear).match(currentBillingYear);
          selectedDate.selected = (matched) ? false : false;
        });
      }
    };
  }]).filter('invoiceDateFormat', ['$filter', function invoiceDateFormat($filter) {
      return function(text, lang) {
        if(lang == 'fr'){
          var date = $filter('date')(text, "dd MMMM yyyy");
          console.log(date);
          var month = date.indexOf('.');
          if(month >= 0){
            return date;
          }else{
           return $filter('date')(text, "dd MMMM yyyy")
          }
        }else{
          return $filter('date')(text, "MMMM dd, yyyy")
        }
      }
  }]);

})();
